import React, { useCallback } from 'react';
import type SearchResultItem from '../../../../domain/search_result_item';
import OutlineItemShortDistanceContainer from './OutlineItemShortDistanceContainer';
import type { Tab } from '../../../../domain/select_store';
import type SelectStore from '../../../../domain/select_store';

interface OutlineItemShortDistanceProps {
  sectionNumber: number;
  item: SearchResultItem;
  handleClickTab: (tab: Tab) => void;
  handleSelectItem: () => void;
  selected: boolean;
  hotelPriceLimit: number | null;
  store: SelectStore;
  isRequestForm: boolean; // ArrangementRequestForm。リクエストフォームで変更ボタンの表示非表示に使用されている
  handleOpenShowSearchBox: () => void;
  isTripsForm?: boolean; // MEMO: TripsFormInformation = trueとSelectOutlineShortDistance = false(未記入)でそれぞれ固定値が渡ってくる。
}

const OutlineItemShortDistance = ({
  sectionNumber,
  item,
  handleClickTab,
  handleSelectItem,
  selected,
  hotelPriceLimit,
  store,
  isRequestForm,
  handleOpenShowSearchBox,
  isTripsForm
}: OutlineItemShortDistanceProps) => {
  const handleCssTransitionExited = useCallback(() => {
    if (item.elementList) {
      item.elementList.handleTransitionExited();
    }
    handleSelectItem();
  }, [item.elementList, handleSelectItem]);

  const setItemLoading = useCallback(
    (loading: boolean) => {
      if (item) {
        item.setLoadingWithSelectedLoading(loading);
      }
    },
    [item]
  );

  return (
    <OutlineItemShortDistanceContainer
      sectionNumber={sectionNumber}
      item={item}
      handleClickTab={handleClickTab}
      selected={selected}
      hotelPriceLimit={hotelPriceLimit}
      store={store}
      isRequestForm={isRequestForm}
      handleOpenShowSearchBox={handleOpenShowSearchBox}
      isTripsForm={isTripsForm}
      handleCssTransitionExited={handleCssTransitionExited}
      setItemLoading={setItemLoading}
    />
  );
};

export default OutlineItemShortDistance;
